export const highlightContent = {
  phrase:
    "Control costs, automate processes, and grow your projects with our system.",
  buttonLabel: "Contact Us",
  buttonLink: "/#contact",
};
